import { render } from "./BankAutomationView.vue?vue&type=template&id=460f37ea"
import script from "./BankAutomationView.vue?vue&type=script&lang=js"
export * from "./BankAutomationView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__